import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@mui/material';

const CancelTripDialog = ({ open, onClose, onConfirm, tripToCancel, isCancelling }) => {
    const [localReason, setLocalReason] = React.useState('');

    // Add cleanup when dialog closes
    React.useEffect(() => {
        if (!open) {
            setLocalReason('');
        }
    }, [open]);

    const handleConfirmWithLocal = () => {
        if (tripToCancel && localReason) {
            onConfirm(localReason);
            setLocalReason('');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Cancel Trip</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please enter a reason for cancelling this trip.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Reason"
                    fullWidth
                    variant="outlined"
                    value={localReason}
                    onChange={(e) => {
                        e.preventDefault();
                        setLocalReason(e.target.value);
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Do Not {(tripToCancel?.tripStage === 'Planned' || tripToCancel?.tripStage === 'Start Delayed') ? 'Cancel' : 'Abort'}</Button>
                <Button
                    onClick={handleConfirmWithLocal}
                    disabled={!localReason || isCancelling}
                    color="error"
                >
                    {isCancelling ? 'Cancelling...' : `Confirm ${(tripToCancel?.tripStage === 'Planned' || tripToCancel?.tripStage === 'Start Delayed') ? 'Cancel' : 'Abort'}`}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelTripDialog;